import { useState } from 'react';
import { useScrollAnimation } from '@/hooks/useScrollAnimation';

const testimonials = [
  {
    name: 'Carlos Muñoz',
    role: 'Gerente de Operaciones',
    company: 'Agroindustrial del Sur',
    text: 'Excelente servicio. IngemetalSur construyó nuestro galpón industrial en tiempo récord y con una calidad impecable. El equipo es muy profesional y responsable. Sin duda los recomendamos.',
    rating: 5,
    location: 'Temuco',
  },
  {
    name: 'María González',
    role: 'Propietaria',
    company: 'Comercial González',
    text: 'Contratamos a IngemetalSur para la construcción de nuestro local comercial en Villarrica. Cumplieron con todos los plazos y el resultado superó nuestras expectativas. Trabajo de calidad.',
    rating: 5,
    location: 'Villarrica',
  },
  {
    name: 'Roberto Soto',
    role: 'Director',
    company: 'Piscicultura Los Andes',
    text: 'Responsables, serios y con mucha experiencia. Realizaron obras civiles para nuestra piscicultura en condiciones difíciles y entregaron un trabajo impecable. Muy satisfechos.',
    rating: 4,
    location: 'Pucón',
  },
  {
    name: 'Ana Pérez',
    role: 'Administradora',
    company: 'Bodega Central Concepción',
    text: 'Buscábamos una constructora confiable para nuestro proyecto en Concepción y IngemetalSur fue la mejor decisión. Profesionales, puntuales y con un equipo muy capacitado.',
    rating: 5,
    location: 'Concepción',
  },
];

const Testimonials = () => {
  const [current, setCurrent] = useState(0);
  const { ref: headerRef, isVisible: headerVisible } = useScrollAnimation();
  const { ref: cardRef, isVisible: cardVisible } = useScrollAnimation();

  const prev = () => setCurrent((c) => (c === 0 ? testimonials.length - 1 : c - 1));
  const next = () => setCurrent((c) => (c === testimonials.length - 1 ? 0 : c + 1));

  const t = testimonials[current];

  return (
    <section className="py-20 bg-[#F8FAFC]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div
          ref={headerRef}
          className={`text-center mb-14 ${headerVisible ? 'reveal-visible' : ''} reveal`}
        >
          <span className="text-[#C88A2A] text-sm font-bold uppercase tracking-widest">Testimonios</span>
          <h2 className="text-3xl md:text-4xl font-black text-[#0C1D2E] mt-2 mb-2">
            Lo que dicen nuestros clientes
          </h2>
          <div className="flex items-center justify-center gap-2 mt-3">
            {[1,2,3,4].map(i => (
              <i key={i} className="ri-star-fill text-yellow-400 text-xl"></i>
            ))}
            <i className="ri-star-half-fill text-yellow-400 text-xl"></i>
            <span className="text-[#475569] text-sm ml-2 font-semibold">4.5 / 5 en Google Reviews</span>
          </div>
        </div>

        <div
          ref={cardRef}
          className={`max-w-3xl mx-auto ${cardVisible ? 'reveal-scale' : 'reveal'} ${cardVisible ? 'reveal-visible' : ''}`}
        >
          <div className="bg-white rounded-xl p-8 md:p-12 relative shadow-sm">
            <i className="ri-double-quotes-l text-[#C88A2A]/10 text-8xl absolute top-4 left-6 leading-none"></i>

            <div className="flex gap-1 mb-6">
              {Array.from({ length: 5 }).map((_, i) => (
                <i
                  key={i}
                  className={`text-xl ${i < t.rating ? 'ri-star-fill text-yellow-400' : 'ri-star-line text-gray-300'}`}
                ></i>
              ))}
            </div>

            <p className="text-[#475569] text-lg leading-relaxed mb-8 relative z-10 italic">
              "{t.text}"
            </p>

            <div className="flex items-center justify-between flex-wrap gap-4">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-full bg-[#1A3A5C] flex items-center justify-center text-white font-bold text-lg">
                  {t.name.charAt(0)}
                </div>
                <div>
                  <div className="font-bold text-[#0C1D2E] text-sm">{t.name}</div>
                  <div className="text-[#475569] text-xs">{t.role} · {t.company}</div>
                  <div className="flex items-center gap-1 mt-0.5">
                    <i className="ri-map-pin-line text-[#C88A2A] text-xs"></i>
                    <span className="text-[#64748B] text-xs">{t.location}</span>
                  </div>
                </div>
              </div>

              <div className="flex gap-2">
                <button
                  onClick={prev}
                  className="w-10 h-10 flex items-center justify-center border border-gray-200 rounded-md hover:bg-gray-50 hover:scale-105 transition-all cursor-pointer"
                  aria-label="Anterior"
                >
                  <i className="ri-arrow-left-line text-[#475569]"></i>
                </button>
                <button
                  onClick={next}
                  className="w-10 h-10 flex items-center justify-center bg-[#1A3A5C] rounded-md hover:bg-[#152e45] hover:scale-105 transition-all cursor-pointer"
                  aria-label="Siguiente"
                >
                  <i className="ri-arrow-right-line text-white"></i>
                </button>
              </div>
            </div>
          </div>

          {/* Dots */}
          <div className="flex justify-center gap-2 mt-6">
            {testimonials.map((_, i) => (
              <button
                key={i}
                onClick={() => setCurrent(i)}
                className={`w-2 h-2 rounded-full transition-all duration-300 cursor-pointer ${
                  i === current ? 'bg-[#1A3A5C] w-6' : 'bg-gray-300 hover:bg-gray-400'
                }`}
                aria-label={`Testimonio ${i + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;